//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DivSpan from '@/components/DivSpan';
import fileUpload from '@/components/file-upload';
export default {
  name: "dynamic-approval",
  props:['value'],
  components:{
    DivSpan,
    fileUpload
  },
  data(){
    return{
      show:false,
      baseShow:false
    }
  },
  methods:{
    changeShow(item){
      if (item.cellShow) {
        this.$set(item,'cellShow',false);
        return;
      }
      this.$set(item,'cellShow',true);
    },
    changeTabShow(item,str){
      if (item[str]) {
        this.$set(item,str,false);
        return;
      }
      this.$set(item,str,true);
    }
  }
}



// WEBPACK FOOTER //
// ./src/page/supplier/approval/dynamic-approval.vue